import { isNonEmptyString } from '@/utils/validators/isNonEmptyString';

// undefined input -> not dirty, don't send.
// empty string / null input -> dirty clear, send null so backend clears the field.
export const getNetworkFieldValue = (
	value: unknown
): string | null | undefined => {
	if (value === undefined) return undefined;
	if (isNonEmptyString(value)) return value;
	return null;
};
